import { IEnvironment } from "./environment.interface";

export const Environment: IEnvironment = {
    "target": "dev",
    apiRoot: "https://pcp.dev.pulte.com/",
    pcpUrl: "https://pcp.dev.pulte.com/",
    bwpUrl: "https://bwp.dev.pulte.com/",
    bqaUrl: "https://bqa.dev.pulte.com/",
    serviceUrl: "https://pultedev.crm.dynamics.com/apps/service",
    reportingUrl: "http://powerbi.dev.pulte.com/Reports/browse/IDEA/Home%20Building%20Operations/Construction%20Operations%20Reports",

    constructionPortalHelpUrl: "https://pulte.sharepoint.com/teams/ConstructionPortal?market=en-US&xsdata=MDV8MDJ8fDRiNTVlZTJkMzgzNTQwNDI0MDY3MDhkZTk5N2Q2MzdjfDFhOTI3N2EzZWY2NjQxZjY5NmI1YzUzOTBlZTQ2OGE3fDB8MHw2MzkxMTY5NjA5NTIyNDEyODR8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T20xbFpYUnBibWRmVFVkR2JFOVVhM2xPYWxsMFdtcEZNMDFUTURCUFIxWnJURmRGZWxscVJYUmFSR3h0V1RKWmVrNXRVbXhaYWxrMFFIUm9jbVZoWkM1Mk1pOXRaWE56WVdkbGN5OHhOemMyTURrNU1qa3pNamczfGM5MDU0YjI2NTg5ZDQ5NzBiODlmMDhkZTk5N2Q2MzdifDFiNjI3ZmUxOTU2MDRhZDA5ZWM0ZjJjOWI2MTg5Yzk4&sdata=dHUyRmJnQ0VDRXlWWDlBbkMwUXkyS3UzV3BBMU9WcTdYL0NFSnVPRGtKZz0%3D&ovuser=1a9277a3-ef66-41f6-96b5-c5390ee468a7%2Chwu%40pulte.com",
    appInsights: {
        "instrumentationKey": "d0558c6c-4295-45e4-b6a9-86a72df00614"
    },
    authConfig: {
        clientId: 'a51e7f67-67f5-4e85-8a4c-ad98d2bd979c',
        issuer: 'https://login.microsoftonline.com/1a9277a3-ef66-41f6-96b5-c5390ee468a7/v2.0',
        responseType: 'code',
        redirectUri: 'https://pcp.dev.pulte.com/',
        scope: 'api://a51e7f67-67f5-4e85-8a4c-ad98d2bd979c/user_impersonation',
        clearHashAfterLogin: true,
        requestAccessToken: true,
        showDebugInformation: true,
        skipIssuerCheck: false,
        strictDiscoveryDocumentValidation: false
    },
    "googleAnalytics": {
        tagManagerUrl: "https://www.googletagmanager.com/gtag/js?id=UA-150271777-2",
        gtagScript: "window.dataLayer = window.dataLayer || []; function gtag(){ dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'UA-150271777-2');"
    },
    "storage": "e992d3bc1af0436eb5906b4293936c7a"
};
